import { useMutation } from 'react-query'

import { createRecurringInvoiceDraft } from '@features/recurringInvoices/query-api'

export const useCreateRecurringInvoiceDraft = () => {
  const { mutate, isLoading: isProcessing } = useMutation(createRecurringInvoiceDraft)

  return { createRecurringInvoiceDraft: mutate, isProcessing }
}
